import { createAction } from 'redux-actions'
import {
  SET_INTEGRAL_DATA,
  REQUEST_INTEGRAL_DATA,
} from '../constants/integralConstant'

export let requestIntegralData = createAction(REQUEST_INTEGRAL_DATA)
export let setIntegralData = createAction(SET_INTEGRAL_DATA)
